import React from "react";
import { useMap } from "react-map-gl";
import { useSelector } from "react-redux";
import { TreeEventLayer, TreeLineEventLayer, BuildingEventLayer, HandleShadeObjectDelete } from "./";
import { HandleFeatureClick } from "../../MapboxFeatureHandlers";

const ShadeLayer = ({ interactive = true }) => {
  const shade_objects = useSelector((state) => state.canopy.shade_objects);
  const selected_shade_object_id = useSelector((state) => state.canopy.selected_shade_object_id);

  return (
    <>
      <HandleFeatureClick features={shade_objects} />
      {selected_shade_object_id && <HandleShadeObjectDelete />}
      {shade_objects &&
        Object.values(shade_objects)?.length > 0 &&
        Object.values(shade_objects)?.map((obj) => {
          if (!obj.checked) return;
          if (obj.shape === "tree") {
            return <TreeEventLayer key={obj.id} tree={obj} interactive={interactive} />;
          } else if (obj.shape === "treeLine") {
            return <TreeLineEventLayer key={obj.id} treeline={obj} interactive={interactive} />;
          } else {
            return <BuildingEventLayer key={obj.id} building={obj} interactive={interactive} />;
          }
        })}
    </>
  );
};

// const ShadeLayerNEW = ({ interactive = true }) => {
//   const shade_objects = useSelector((state) => state.canopy.shade_objects);
//   const selected_shade_object_id = useSelector((state) => state.canopy.selected_shade_object_id);

//   return (
//     <>
//       <HandleFeatureClick features={shade_objects} />
//       {selected_shade_object_id && <HandleShadeObjectDelete />}
//       {shade_objects &&
//         Object.values(shade_objects)?.length > 0 &&
//         Object.values(shade_objects)
//           ?.filter((obj) => obj.checked)
//           .map((obj) => <ShadeObjectLayer key={obj.id} obj={obj} interactive={interactive} />)}
//     </>
//   );
// };

// const ShadeObjectLayer = ({ obj, interactive }) => {
//   const LayerComponent = obj.shape === "tree" ? TreeEventLayer : obj.shape === "treeLine" ? TreeLineEventLayer : BuildingEventLayer;

//   return (
//     <>
//       <LayerComponent key={obj.id} {...{ [obj.shape]: obj, interactive }} />
//       <ShadeObjectHover obj={obj} />
//     </>
//   );
// };

export { ShadeLayer };
